import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef, useCallback } from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { B as BaseMenuItemMixin, M as MenuItem } from './MenuItem.styles-BNyjRUur.js';
import { K as KEYBOARD_KEYNAMES } from '../../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-AmBipDtf-AmBipDtf.js';
import { T as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';

const ItemLink = /*#__PURE__*/styled('a').withConfig({
  componentId: "sc-storm-ui-30060407__sc-bhplnc-0"
})(["", " a&,a&:visited,a&:active,a&:link{", "}display:block;line-height:1.865;text-decoration:none;", ""], BaseMenuItemMixin, ({
  theme,
  $disabled
}) => $disabled ? css(["color:", ";cursor:not-allowed;"], theme.dropdown.item.colorDisabled) : css(["color:", ";cursor:pointer;"], theme.dropdown.item.color), isMobile(css(["", ";min-height:", ";line-height:2.865;"], ({
  theme
}) => theme.typography.mobile.base, ({
  theme
}) => theme.dropdown.item.mobile.minHeight)));
const MenuItemLink = ({
  children,
  disabled,
  href,
  rel = 'noopener noreferrer',
  target = '_blank',
  onClick,
  taktId,
  taktValue,
  ...rest
}) => {
  const linkRef = useRef(null);
  const onClickHandler = useCallback(event => {
    if (disabled) {
      event.preventDefault();
    } else {
      onClick === null || onClick === void 0 || onClick(event);
    }
    event.stopPropagation();
  }, [disabled, onClick]);
  const onKeyDown = useCallback(event => {
    const {
      key
    } = event;
    if (!disabled && (key === KEYBOARD_KEYNAMES.ENTER || key === KEYBOARD_KEYNAMES.SPACE)) {
      var _linkRef$current;
      (_linkRef$current = linkRef.current) === null || _linkRef$current === void 0 || _linkRef$current.click();
    }
  }, [disabled]);
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('menu-item-button')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(MenuItem, null, /*#__PURE__*/React__default.createElement(ItemLink, _extends({}, getDataTaktAttributes(), rest, {
    href: disabled ? undefined : href,
    ref: linkRef,
    rel: rel,
    target: target,
    tabIndex: disabled ? -1 : 0,
    $disabled: disabled,
    "aria-disabled": disabled,
    onClick: onClickHandler,
    onKeyDown: onKeyDown
  }), children)));
};
MenuItemLink.defaultProps = {
  disabled: false
};

export { MenuItemLink as M };
//# sourceMappingURL=MenuItemLink-DE_prweY.js.map
